// src/components/Header.js (GÜNCELLE)
import React, { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";

export default function Header({ currentRoute = "/" }) {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((s) => !s);
  const closeMenu = () => setOpen(false);

  const isCurrent = (path) => (currentRoute === path ? "page" : undefined);

  return (
    <header className="site-header">
      <a href="main-content" className="skip-link">
        İçeriğe atla
      </a>

      <div className="container header-inner">
        {/* Sol: Marka */}
        <a
          className="brand"
          href="/"
          aria-label="Ana sayfa"
          onClick={closeMenu}
        >
          {/* LOGO */}
          <img
            src="/logo.svg" // logo.svg'yi public/ içine koyduysan bu yeterli
            className="brand-logo"
            alt="Bağcı Hafriyat"
          />
          {/* Erişilebilirlik için ekstra metin istersen: 
          <span className="sr-only">Bağcı Hafriyat</span>
          */}
        </a>

        {/* Orta: Genişleyen NAV (desktop’ta yayılır) */}
        <nav
          id="site-nav"
          className={`nav ${open ? "open" : ""}`}
          role="navigation"
          aria-label="Ana menü"
        >
          <a
            href="/"
            className="nav-link"
            aria-current={isCurrent("/")}
            onClick={closeMenu}
          >
            Ana Sayfa
          </a>
          <a
            href="/about"
            className="nav-link"
            aria-current={isCurrent("/about")}
            onClick={closeMenu}
          >
            Hakkımızda
          </a>
          <a
            href="/policies"
            className="nav-link"
            aria-current={isCurrent("/policies")}
            onClick={closeMenu}
          >
            Politikalar
          </a>
          <a
            href="/services"
            className="nav-link"
            aria-current={isCurrent("/services")}
            onClick={closeMenu}
          >
            Hizmetlerimiz
          </a>
          <a
            href="/projects"
            className="nav-link"
            aria-current={isCurrent("/projects")}
            onClick={closeMenu}
          >
            Referanslar
          </a>
          <a
            href="/fleet"
            className="nav-link"
            aria-current={isCurrent("/fleet")}
            onClick={closeMenu}
          >
            Araç Parkuru
          </a>
          <a
            href="/gallery"
            className="nav-link"
            aria-current={isCurrent("/gallery")}
            onClick={closeMenu}
          >
            Galeri
          </a>
          <a
            href="/catalog"
            className="nav-link"
            aria-current={isCurrent("/catalog")}
            onClick={closeMenu}
          >
            Katalog
          </a>
          <a
            href="/contact"
            className="nav-link"
            aria-current={isCurrent("/contact")}
            onClick={closeMenu}
          >
            İletişim
          </a>
        </nav>

        {/* Sağ: Desktop CTA (şimdilik boş) */}
        <div className="header-cta">{/* <a ...>Teklif Al</a> */}</div>

        {/* Burger (sadece mobil) */}
        <button
          className="menu-toggle"
          aria-expanded={open}
          aria-controls="site-nav"
          aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
          onClick={toggle}
        >
          <RxHamburgerMenu />
          <span className="sr-only">Menüyü aç/kapat</span>
        </button>
      </div>
    </header>
  );
}